<template>
    <b-modal
            ref="dmiContactModal"
            :id="id"
            title="Your Business Card">
        <template slot="modal-footer">
            <b-button variant="secondary" @click="$refs.dmiContactModal.hide()">
                CANCEL
            </b-button>
            <pb-btn :busy="submitProcessing" variant="primary"
                    v-on:click.native="onSubmit">
                SEND
            </pb-btn>
        </template>
        <b-container class="text-left">
            <b-row>
                <b-col>
                    <b-form @submit="onSubmit">
                        <b-row class="my-2">
                            <b-col>
                                <label for="email">Email:</label>
                                <b-form-input
                                        :disabled="formData.newCustomer != null"
                                        id="email"
                                        name="email"
                                        type="text"
                                        placeholder="Email"
                                        v-model.trim="formData.email"
                                        v-validate="'required|email'"
                                        class="secondary"
                                        :state="validateState('email')"
                                ></b-form-input>
                            </b-col>
                        </b-row>
                        <b-row class="my-2">
                            <b-col>
                                <fieldset class="form-group">
                                    <label for="company">Company:</label>
                                    <b-form-input
                                            id="company"
                                            name="company"
                                            type="text"
                                            placeholder="Company"
                                            v-model.trim="formData.company"
                                            v-validate="'required'"
                                            class="secondary"
                                            :state="validateState('company')"
                                    ></b-form-input>
                                </fieldset>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-col>
            </b-row>
        </b-container>
    </b-modal>
</template>
<script>


    function initialData() {
        return {
            submitProcessing: false,
            formData: {
                company: null,
                email: null
            }
        }
    }

    import UserApi from "@shared/_api/user";

    export default {
        name: 'dmi-contact-modal',
        props: {
            id: String
        },
        data() {
            return {...initialData()};
        },
        methods: {
            show() {
                this.$refs.dmiContactModal.show();
            },
            resetData() {
                this.$validator.reset().finally(() => {
                    Object.assign(this.$data, initialData());
                });
            },
            onSubmit(evt) {
                evt.preventDefault();
                this.$validator.validate().then(valid => {
                    if (valid) {
                        this.submitProcessing = true;
                        UserApi.sendBusinessCard(this.formData.email, this.formData.company).catch(() => {
                        }).finally(() => {
                            this.submitProcessing = false;
                            window.$cookies.set('business-card-sent', 1, "90D");
                            this.$refs.dmiContactModal.hide();
                        });
                    }
                });
            },
            validateState(ref) {
                if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                    return !this.errors.has(ref)
                }
                return null
            },
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

</style>
